import React from 'react';
import { Container, Card, Row, Col, Badge, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="section-modern py-5" style={{ paddingTop: '120px' }}>
        <Container>
          <div className="section-header text-center mb-5">
            <Badge bg="secondary" className="section-badge mb-3">Privacy Policy</Badge>
            <h2 className="section-title">Privacy Policy</h2>
            <p className="section-subtitle">Your privacy is important to us</p>
          </div>
          <Row>
            <Col lg={10} className="mx-auto">
              <Card className="card-modern border-0 shadow-sm">
                <Card.Body className="p-5">
                  <div className="privacy-content">
                    
                    <h5 className="mt-4 mb-3">Information We Collect</h5>
                    <p className="mb-3">
                      We collect information when you create an account, submit forms, or contact us for 
                      inquiries about our educational services. This may include personal information such 
                      as your name, email address, phone number, address, and any other details you provide 
                      to us voluntarily.
                    </p>

                    <h5 className="mt-4 mb-3">How We Use Your Information</h5>
                    <p className="mb-3">
                      The information we collect is used to provide, maintain, and improve our educational 
                      services. We use this information to process applications, communicate with you about 
                      our programs and services, respond to your inquiries, send important updates and 
                      notifications, and comply with legal obligations. We may also use your information 
                      to enhance your experience on our website and to ensure the security of our services.
                    </p>

                    <h5 className="mt-4 mb-3">Information Sharing</h5>
                    <p className="mb-3">
                      We do not sell, trade, or transfer your personal information to third parties without 
                      your consent, except as described in this Privacy Policy. We may share your information 
                      with trusted service providers who assist us in operating our website and conducting 
                      our business, provided that these parties agree to keep your information confidential. 
                      We may also disclose your information when required by law or to protect our rights, 
                      property, or safety, or that of our students and staff.
                    </p>

                    <h5 className="mt-4 mb-3">Data Security</h5>
                    <p className="mb-3">
                      We implement appropriate technical and organizational security measures to protect your 
                      personal information against unauthorized access, alteration, disclosure, or destruction. 
                      These measures include encryption, secure servers, and regular security assessments. 
                      However, please note that no method of transmission over the internet or electronic 
                      storage is 100% secure, and we cannot guarantee absolute security of your information.
                    </p>

                    <h5 className="mt-4 mb-3">Your Rights</h5>
                    <p className="mb-3">
                      You have the right to access, update, or delete your personal information at any time. 
                      If you would like to exercise any of these rights, please contact us using the contact 
                      information provided below. We will respond to your request within a reasonable timeframe 
                      and in accordance with applicable laws. You also have the right to object to the processing 
                      of your personal information or to withdraw your consent where processing is based on consent.
                    </p>

                    <h5 className="mt-4 mb-3">Contact Us</h5>
                    <p className="mb-0">
                      If you have any questions about this Privacy Policy or our data practices, please contact us at:
                    </p>
                    <p className="mt-2 mb-4">
                      <strong>Email:</strong> reachus@deepjyotischool.org<br />
                      <strong>Address:</strong> Mira Road East, Thane, Maharashtra, India
                    </p>
                    
                    <div className="text-center mt-4">
                      <Link to="/">
                        <Button variant="primary" className="btn-modern">
                          ← Back to Home
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
